export default __webpack_public_path__ + "static/media/30.8ad73546.jpg";